import { MenuElement } from '@shared/interfaces/header/menu-element';
import { ChartCandlestick, CircleGauge, HousePlug, LayoutGrid, Server, TrendingUpDown, User, ListChecks } from 'lucide-angular';
import { AuthRoles } from '@app/api/dmc';


/**
 * Represents a hierarchical structure for the application's menu.
 *
 * Each menu is categorized into a `label` that represents the menu section
 * and an array of `items` that define the individual elements within that section.
 *
 * Properties:
 * - `label`: A string representing the section name of the menu (e.g., 'menu.overview').
 * - `items`: An array of `MenuElement` objects, where each object represents a menu item
 *   with its title, associated icon, and navigation route.
 *
 * Example structure:
 * - Overview Section:
 *   - Dashboard item with a specified icon and route
 *   - Search item with a specified icon and route
 * - Model Section:
 *   - Connection Point item
 *   - Measurement Point item
 * - Market Section:
 *   - VEE item
 *   - Pricing item
 *   - Actors item
 *   - Settlement item
 *
 * Note: MenuElement contains the following attributes:
 *   - `title`: The title of the menu item.
 *   - `icon`: The UI icon associated with the menu item.
 *   - `route`: The navigation route defined for the menu item.
 */
export const menu: { label: string, items: MenuElement[] }[] = [
  {
    label: 'menu.overview',
    items: [
      { title: 'menu.dashboard', icon: LayoutGrid, route: 'dashboard' },
    ]
  },
  {
    label: 'menu.model',
    items: [
      { title: 'menu.connectionpoint', icon: HousePlug, route: 'connectionpoint', roles: [AuthRoles.ConnectionPointReader, AuthRoles.ConnectionPointWriter], resetSearchStorage: true },
      { title: 'menu.measurementpoint', icon: CircleGauge, route: 'meteringpoint', roles: [AuthRoles.MeteringPointReader, AuthRoles.MeteringPointWriter], resetSearchStorage: true },
    ]
  },
  {
    label: 'menu.market',
    items: [
      { title: 'menu.vee', icon: TrendingUpDown, route: 'vee', roles: [AuthRoles.VEEReader, AuthRoles.VEEWriter] },
      { title: 'menu.pricing', icon: ChartCandlestick, route: 'chargeinformation', roles: [AuthRoles.ChargeInformationReader, AuthRoles.ChargeInformationWriter] },
      { title: 'menu.actors', icon: User, route: 'actors' },
      { title: 'menu.settlement', icon: ListChecks, route: 'settlement', roles: [AuthRoles.AggregatedDataReader] }
    ]
  },
  {
    label: 'menu.developer',
    items: [
      { title: 'menu.hangfire', icon: Server, href: '/hangfire/', openInNewTab: true, roles: [AuthRoles.Hangfire] },
    ]
  }
]
